// src/components/MothersDay/CTAButton.js
import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import styles from '../../styles/MothersDay.module.css';

const CTAButton = ({ 
  children, 
  className, 
  onClick,
  linkTo = '/packages',
  applyDiscount = true 
}) => {
  const navigate = useNavigate();

  const handleClick = (e) => {
    // If there's a custom onClick handler, call it
    if (onClick) {
      onClick(e);
    }

    // If we should apply the discount
    if (applyDiscount) {
      // Store discount in localStorage
      localStorage.setItem('activeDiscount', 'MOM2025');
      
      // Navigate with the discount parameter
      navigate(`${linkTo}?discount=MOM2025`);
      
      // Prevent default Link behavior since we're handling navigation
      e.preventDefault();
    }
  };

  return (
    <Link 
      to={applyDiscount ? `${linkTo}?discount=MOM2025` : linkTo}
      className={className}
      onClick={handleClick}
    >
      {children}
    </Link>
  );
};

export default CTAButton;